import {AxiosRequestConfig, AxiosResponse} from 'axios'
import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IPageOption} from '../../interface/paging/paging'
import {IApiResponse, IApiListResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {ITagType, ITagTypeByChild, ITagTypeCreate, ITagTypeUpdate} from '../../interface/tag-type'
import {IBaseAttributeGroup} from '../../interface/tag'

export class GetTagTypeService extends Request {
  async request(options?: IPageOption) {
    try {
      const {data} = await this.client
        .get<IApiListResponse<ITagType[]>>(API_PATH.TAG_TYPE, {
          params: options,
        })
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetTagTypeFilterService extends Request {
  async request(options?: IPageOption, filter?: any) {
    try {
      for (let key in filter) {
        if (filter.hasOwnProperty(key) && filter[key] === '') {
          filter[key] = undefined
        }
      }
      const {data} = await this.client
        .post<IApiListResponse<ITagType[]>>(
          `${API_PATH.TAG_TYPE}/filter`,
          {
            ...filter,
          },
          {
            params: options,
          }
        )
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateTagTypeService extends Request {
  async request(payload: ITagTypeCreate) {
    const {data} = await this.client.post<ITagType>(API_PATH.TAG_TYPE, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class UpdateTagTypeService extends Request {
  async request(payload: ITagTypeUpdate) {
    try {
      const {data} = await this.client.patch<ITagType>(API_PATH.TAG_TYPE, payload)
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class DeleteTagTypeService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .delete<IApiResponse<any>>(`${API_PATH.TAG_TYPE}/${id}`)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTagTypeByIdService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<ITagType[]>>(`${API_PATH.TAG_TYPE}/get-by-id/${id}`)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetTagTypeByTagPropertyService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<any>(`${API_PATH.TAG_TYPE}/get-tag-property/${id}`)
        .then((d) => d.data)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTagTypeByDisciplineService extends Request {
  async request(id: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<ITagType[]>>(`${API_PATH.TAG_TYPE}/get-by-discipline-id/${id}`)
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class GetTagTypeByChildService extends Request {
  async request(parentId: string) {
    try {
      const {data} = await this.client
        .get<IApiResponse<ITagTypeByChild[]>>(`${API_PATH.TAG_TYPE}/get-child/${parentId}`)
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetTagTypeLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.TAG_TYPE}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
